// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"f942114e","455":"a1c3ac9a","977":"6876d6f3"}[chunkId] + ".chunk.js";
};